import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import {HashRouter, Routes, Route} from "react-router-dom";
import Home from "./components/home";
import {SuivisCommercial} from "./components/suivisCommercial";


function App() {
  return (
    <div>
      <HashRouter>
        <Routes>
          <Route index element={<Home/>}/>
          <Route path="/suivisCommercial" element={<SuivisCommercial/>}/>
        </Routes>
      </HashRouter>
    </div>

  );
}

export default App;
